import React, { useEffect, useState } from 'react'

const MyTabButton = ({ name, value, setValue, valueChoose }) => {

    const [active, setActive] = useState(false)

    useEffect(() => {
        setItemActive()
    }, [value, setValue])

    const setItemActive = () => {
        if (value && valueChoose && value === valueChoose) {
            setActive(true)
        } else {
            setActive(false)
        }
    }

  return (
    <div
        className={active ? 'active' : ''}
        onClick={e => {
            setValue(value)
        }}
    >
        { name }
    </div>
  )
}

export default MyTabButton